import jsonServerProvider from 'ra-data-json-server';
import { fetchUtils } from 'react-admin';


const httpClient = (url, options = {}) => {
    if (!options.headers) {
        options.headers = new Headers({ Accept: 'application/json' });
    }
    const token = localStorage.getItem('token');
    options.headers.set('Authorization', `Bearer ${token}`);
    return fetchUtils.fetchJson(url, options);
}
// read from cookie end-point override
const cookies = document.cookie;
if (cookies) {
    const acookies = cookies.split(';');
    if (acookies) for (const cookie of acookies) {
        const kv = cookie.split('=');
        if (kv && kv.length>1 && kv[0].trim() === 'nobid_endpoint') {
            window.nobid_endpoint = kv[1];
        }
    }
}
console.log('%c**********************************************************************', 'color: lime');
console.log(`%cUsing endpoint: ${window.nobid_endpoint}`, 'color: lime');
console.log('%c**********************************************************************', 'color: lime');
export default jsonServerProvider(window.nobid_endpoint, httpClient);